import { render, staticRenderFns } from "./DeRepartizat.vue?vue&type=template&id=a816f7c8&scoped=true&"
import script from "./DeRepartizat.ts?vue&type=script&lang=ts&"
export * from "./DeRepartizat.ts?vue&type=script&lang=ts&"
import style0 from "./DeRepartizat.vue?vue&type=style&index=0&id=a816f7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a816f7c8",
  null
  
)

export default component.exports
import {QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd}, component.options.components || {})
